import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { captureLinkIncentive, type LinkIncentive } from '@/services/link-incentive';

/**
 * The incentive the campaign link asked for (`iid`), remembered for the visit.
 * Must render under a Suspense boundary (Next's `useSearchParams` contract for
 * a statically exported page).
 */
export function useLinkIncentive(): LinkIncentive | undefined {
  const search = useSearchParams().toString();
  return useMemo(() => captureLinkIncentive(search), [search]);
}
